export interface AssetDetails {
  FileName: string;
  AssetName: string;
  DateAdded: string;
  Type: string;
  ClientKey?: string;
  Id?: string;
}
